<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-header">
        <h3>Configure Company Compliance Types</h3>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body">
        @for (type of companyComplianceTypes; track type; let last = $last) {
          <div
            class="row justify-content-between align-items-center"
            [ngClass]="{ 'border-bottom': !last }"
          >
            <div class="col-4">
              <label>{{ type.type }}</label>
            </div>
            @if (!nonEditableComplianceTypes.includes(type.type!)) {
              <div class="col-2">
                <div class="row align-items-center">
                  <div class="col-6">
                    <a
                      class="text-primary"
                      role="button"
                      (click)="editType(type)"
                    >
                      <i class="bi bi-pencil-square fs-28"></i>
                    </a>
                  </div>
                  <div class="col-6">
                    <a
                      class="text-danger"
                      role="button"
                      (click)="deleteType(type)"
                    >
                      <i class="bi bi-trash fs-28"></i>
                    </a>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="modal-footer">
        <div class="col-4">
          <button type="button" class="btn btn-primary" (click)="addNewType()">
            Add new type
          </button>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn-danger" (click)="close()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
